import { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";
import GradientBg from "@/components/common/GradientBg";
import api from "@/lib/api";

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  const [open, setOpen] = useState(0);

  useEffect(() => {
    api.get("/public/faqs").then((r) => setFaqs(r.data.faqs));
  }, []);

  return (
    <div className="relative">
      <GradientBg variant="soft" />
      <section className="relative mx-auto max-w-3xl px-6 pt-24 pb-16">
        <div className="text-xs uppercase tracking-[0.2em] text-primary font-bold">FAQ</div>
        <h1 className="mt-3 text-5xl md:text-6xl font-black tracking-tight">Questions, answered.</h1>
        <p className="mt-4 text-muted-foreground">Can't find what you're looking for? Reach out to our team any time.</p>
      </section>

      <section className="mx-auto max-w-3xl px-6 pb-24 space-y-3">
        {faqs.map((f, i) => (
          <div key={i} className="surface overflow-hidden">
            <button
              onClick={() => setOpen(open === i ? -1 : i)}
              data-testid={`faq-item-${i}`}
              className="w-full flex items-center justify-between px-6 py-5 text-left hover:bg-muted/40 transition-colors"
            >
              <span className="font-semibold text-base">{f.q}</span>
              <ChevronDown
                size={16}
                className={`text-muted-foreground transition-transform duration-300 ${open === i ? "rotate-180" : ""}`}
              />
            </button>
            {open === i && (
              <div className="px-6 pb-5 text-sm text-muted-foreground leading-relaxed border-t border-border/60 pt-4">
                {f.a}
              </div>
            )}
          </div>
        ))}
      </section>
    </div>
  );
}
